import React from 'react'
import SocketIOClinet from 'socket.io-client';
import {STRAPI_DEVELOPMENT, STRAPI_PRODUCTION} from '../constants/Api'


const socket = SocketIOClinet(
    process.env.NODE_ENV === 'production' ? STRAPI_PRODUCTION : STRAPI_DEVELOPMENT
)


export const withSocket = (Component) => {
    return class extends React.Component {
        render() {
            return (
                <Component {...this.props} socket={socket} />
            );
        }
    }
}